<template>
<g>
  <g style="transform: scale(0.7)">
    <text transform="matrix(1 0 0 1 80 60)" class="name">모터드라이버{{number}}</text>
    <path class="st0" d="M97,339.26c-17.65,0-32-14.35-32-32V105c0-17.65,14.35-32,32-32h386c17.65,0,32,14.35,32,32v202.26
        c0,17.65-14.35,32-32,32H97z"/>
    <path class="st1" d="M483,336.26H97c-16.02,0-29-12.98-29-29V105c0-16.02,12.98-29,29-29h386c16.02,0,29,12.98,29,29v202.26
        C512,323.28,499.02,336.26,483,336.26z"/>
    <g>
        <g>
            <circle class="st2" cx="103" cy="110" r="18"/>
        </g>
        <g>
            <circle class="st3" cx="103" cy="109.75" r="25"/>
            <polygon class="st4" points="118,107.25 105.5,107.25 105.5,94.75 100.5,94.75 100.5,107.25 88,107.25 88,112.25 100.5,112.25
                100.5,124.75 105.5,124.75 105.5,112.25 118,112.25"/>
        </g>
    </g>
    <g>
        <circle class="st3" cx="103" cy="300.75" r="25"/>
        <g>
            <circle class="st2" cx="103" cy="300.75" r="18"/>
            <polygon class="st4" points="118,298.25 105.5,298.25 105.5,285.75 100.5,285.75 100.5,298.25 88,298.25 88,303.25 100.5,303.25
                100.5,315.75 105.5,315.75 105.5,303.25 118,303.25"/>
        </g>
    </g>
    <g>
        <circle class="st3" cx="476.75" cy="300.75" r="25"/>
        <g>
            <circle class="st2" cx="476.75" cy="300.75" r="18"/>
            <polygon class="st4" points="491.75,298.25 479.25,298.25 479.25,285.75 474.25,285.75 474.25,298.25 461.75,298.25
                461.75,303.25 474.25,303.25 474.25,315.75 479.25,315.75 479.25,303.25 491.75,303.25"/>
        </g>
    </g>
    <g>
        <circle class="st3" cx="476.75" cy="110.75" r="25"/>
        <g>
            <circle class="st2" cx="476.75" cy="110.75" r="18"/>
            <polygon class="st4" points="491.75,108.25 479.25,108.25 479.25,95.75 474.25,95.75 474.25,108.25 461.75,108.25 461.75,113.25
                474.25,113.25 474.25,125.75 479.25,125.75 479.25,113.25 491.75,113.25"/>
        </g>
    </g>
    <g>
        <path class="st5" d="M158.33,292.51c0,0.22-0.01,0.4-0.04,0.55s-0.06,0.27-0.11,0.36s-0.1,0.15-0.16,0.19s-0.13,0.06-0.2,0.06
            h-3.64v3.97c0,0.08-0.02,0.15-0.06,0.21s-0.11,0.11-0.2,0.15s-0.22,0.08-0.38,0.1s-0.35,0.04-0.59,0.04s-0.43-0.01-0.59-0.04
            s-0.28-0.06-0.38-0.1s-0.16-0.09-0.21-0.15s-0.06-0.13-0.06-0.21v-3.97h-3.63c-0.07,0-0.13-0.02-0.19-0.06s-0.11-0.1-0.16-0.19
            s-0.08-0.21-0.11-0.36s-0.04-0.33-0.04-0.55c0-0.21,0.01-0.39,0.04-0.54s0.06-0.27,0.1-0.36s0.09-0.15,0.15-0.19
            s0.12-0.06,0.19-0.06h3.67v-3.96c0-0.08,0.02-0.15,0.06-0.22s0.11-0.12,0.21-0.16s0.22-0.08,0.38-0.1s0.35-0.04,0.59-0.04
            s0.43,0.01,0.59,0.04s0.28,0.06,0.38,0.1s0.16,0.1,0.2,0.16s0.06,0.14,0.06,0.22v3.96h3.68c0.06,0,0.12,0.02,0.18,0.06
            s0.11,0.1,0.15,0.19s0.08,0.21,0.1,0.36S158.33,292.3,158.33,292.51z"/>
    </g>
    <g>
        <path class="st5" d="M169.66,291.26h11.05v2.49h-11.05V291.26z"/>
    </g>
    <circle class="st6" cx="391.83" cy="221.83" r="15.83"/>
    <g>
        <circle class="st7" cx="391.83" cy="221.83" r="10.66"/>
        <circle class="st8" cx="391.83" cy="221.83" r="8.62"/>
    </g>
    <circle class="st6" cx="391.83" cy="257.9" r="15.83"/>
    <g>
        <circle class="st9" cx="391.83" cy="257.9" r="10.66"/>
        <circle class="st10" cx="391.83" cy="257.9" r="8.62"/>
    </g>
    <rect x="136.36" y="302" class="st11" width="54.43" height="34.54"/>
    <rect x="200.5" y="290.5" class="st12" width="180" height="43"/>
    <!-- left main supply -->
    <g class="pin">
        <rect x="147.25" y="314.75" class="st13" width="11.51" height="11.51"/>
        <path class="st14" d="M160.03,327.53h-14.07v-14.07h14.07V327.53z M148.52,324.98h8.95v-8.95h-8.95V324.98z"/>
        <rect :id="`${pincode}MP`" @click="onClick(`${pincode}MP`)" class="pin-cover terminal" x="147" y="314" width="15" height="15"/>
    </g>
    <g class="pin">
        <rect x="169.25" y="314.75" class="st13" width="11.51" height="11.51"/>
        <path class="st14" d="M182.03,327.53h-14.07v-14.07h14.07V327.53z M170.52,324.98h8.95v-8.95h-8.95V324.98z"/>
        <rect :id="`${pincode}MM`" @click="onClick(`${pincode}MM`)" class="pin-cover terminal" x="169" y="314" width="15" height="15"/>
    </g>
    <g>
        <path class="st5" d="M411.33,292.51c0,0.22-0.01,0.4-0.04,0.55s-0.06,0.27-0.11,0.36s-0.1,0.15-0.16,0.19s-0.13,0.06-0.2,0.06
            h-3.64v3.97c0,0.08-0.02,0.15-0.06,0.21s-0.11,0.11-0.2,0.15s-0.22,0.08-0.38,0.1s-0.35,0.04-0.59,0.04s-0.43-0.01-0.59-0.04
            s-0.28-0.06-0.38-0.1s-0.16-0.09-0.21-0.15s-0.06-0.13-0.06-0.21v-3.97h-3.63c-0.07,0-0.13-0.02-0.19-0.06s-0.11-0.1-0.16-0.19
            s-0.08-0.21-0.11-0.36s-0.04-0.33-0.04-0.55c0-0.21,0.01-0.39,0.04-0.54s0.06-0.27,0.1-0.36s0.09-0.15,0.15-0.19
            s0.12-0.06,0.19-0.06h3.67v-3.96c0-0.08,0.02-0.15,0.06-0.22s0.11-0.12,0.21-0.16s0.22-0.08,0.38-0.1s0.35-0.04,0.59-0.04
            s0.43,0.01,0.59,0.04s0.28,0.06,0.38,0.1s0.16,0.1,0.2,0.16s0.06,0.14,0.06,0.22v3.96h3.68c0.06,0,0.12,0.02,0.18,0.06
            s0.11,0.1,0.15,0.19s0.08,0.21,0.1,0.36S411.33,292.3,411.33,292.51z"/>
    </g>
    <g>
        <path class="st5" d="M422.66,291.26h11.05v2.49h-11.05V291.26z"/>
    </g>
    <rect x="389.36" y="302" class="st11" width="54.43" height="34.54"/>
    <!-- right slave supply -->
    <g class="disable">
        <rect x="400.25" y="314.75" class="st13" width="11.51" height="11.51"/>
        <path class="st14" d="M413.03,327.53h-14.07v-14.07h14.07V327.53z M401.52,324.98h8.95v-8.95h-8.95V324.98z"/>
    </g>
    <g class="disable">
        <rect x="422.25" y="314.75" class="st13" width="11.51" height="11.51"/>
        <path class="st14" d="M435.03,327.53h-14.07v-14.07h14.07V327.53z M423.52,324.98h8.95v-8.95h-8.95V324.98z"/>
    </g>
    <g>
        <path class="st5" d="M217.06,300.96h-0.02l-1.36,0.73l-0.2-0.8l1.7-0.91h0.9v7.8h-1.02V300.96z"/>
    </g>
    <g>
        <path class="st5" d="M230.78,307.78v-0.65l0.83-0.8c1.99-1.9,2.89-2.9,2.9-4.08c0-0.79-0.38-1.52-1.55-1.52
            c-0.71,0-1.3,0.36-1.66,0.66l-0.34-0.74c0.54-0.46,1.31-0.79,2.21-0.79c1.68,0,2.39,1.15,2.39,2.27c0,1.44-1.04,2.6-2.69,4.19
            l-0.62,0.58v0.02h3.5v0.88H230.78z"/>
    </g>
    <g>
        <path class="st5" d="M247.04,306.57c0.3,0.19,1,0.49,1.73,0.49c1.36,0,1.78-0.86,1.76-1.51c-0.01-1.09-1-1.56-2.01-1.56h-0.59
            v-0.79h0.59c0.77,0,1.74-0.4,1.74-1.32c0-0.62-0.4-1.18-1.37-1.18c-0.62,0-1.22,0.28-1.56,0.52l-0.28-0.77
            c0.41-0.3,1.2-0.6,2.04-0.6c1.54,0,2.23,0.91,2.23,1.86c0,0.8-0.48,1.49-1.44,1.83v0.02c0.96,0.19,1.74,0.91,1.74,2
            c0,1.25-0.97,2.34-2.84,2.34c-0.88,0-1.64-0.28-2.03-0.53L247.04,306.57z"/>
    </g>
    <g>
        <path class="st5" d="M267.06,307.78v-2.12h-3.62v-0.7l3.48-4.98h1.14v4.85h1.09v0.83h-1.09v2.12H267.06z M267.06,304.83v-2.6
            c0-0.41,0.01-0.82,0.04-1.22h-0.04c-0.24,0.46-0.43,0.79-0.65,1.15l-1.91,2.65v0.02H267.06z"/>
    </g>
    <g>
        <path class="st5" d="M284.46,300.87h-2.97l-0.3,2c0.18-0.02,0.35-0.05,0.64-0.05c0.6,0,1.2,0.13,1.68,0.42
            c0.61,0.35,1.12,1.02,1.12,2c0,1.52-1.21,2.66-2.9,2.66c-0.85,0-1.57-0.24-1.94-0.48l0.26-0.8c0.32,0.19,0.96,0.43,1.67,0.43
            c1,0,1.85-0.65,1.85-1.69c-0.01-1.01-0.68-1.73-2.24-1.73c-0.44,0-0.79,0.05-1.08,0.08l0.5-3.74h3.73V300.87z"/>
    </g>
    <g>
        <path class="st5" d="M299.26,300.72c-0.22-0.01-0.49,0-0.79,0.05c-1.65,0.28-2.53,1.49-2.71,2.77h0.04c0.37-0.49,1.02-0.9,1.88-0.9
            c1.38,0,2.35,1,2.35,2.52c0,1.43-0.97,2.75-2.59,2.75c-1.67,0-2.76-1.3-2.76-3.32c0-1.54,0.55-2.75,1.32-3.51
            c0.65-0.64,1.51-1.03,2.5-1.15c0.31-0.05,0.58-0.06,0.77-0.06V300.72z M298.96,305.22c0-1.12-0.64-1.79-1.61-1.79
            c-0.64,0-1.22,0.4-1.51,0.96c-0.07,0.12-0.12,0.28-0.12,0.47c0.02,1.28,0.61,2.23,1.71,2.23
            C298.35,307.09,298.96,306.34,298.96,305.22z"/>
    </g>
    <g>
        <path class="st5" d="M316.88,299.98v0.7l-3.39,7.1h-1.09l3.38-6.9v-0.02h-3.81v-0.88H316.88z"/>
    </g>
    <g>
        <path class="st5" d="M327.74,305.8c0-0.98,0.59-1.68,1.55-2.09l-0.01-0.04c-0.86-0.41-1.24-1.08-1.24-1.75
            c0-1.24,1.04-2.08,2.41-2.08c1.51,0,2.27,0.95,2.27,1.92c0,0.66-0.32,1.37-1.28,1.82v0.04c0.97,0.38,1.57,1.07,1.57,2.02
            c0,1.36-1.16,2.27-2.65,2.27C328.72,307.91,327.74,306.94,327.74,305.8z M331.93,305.75c0-0.95-0.66-1.4-1.71-1.7
            c-0.91,0.26-1.4,0.86-1.4,1.61c-0.04,0.79,0.56,1.49,1.56,1.49C331.32,307.14,331.93,306.55,331.93,305.75z M329.03,301.85
            c0,0.78,0.59,1.2,1.49,1.44c0.67-0.23,1.19-0.71,1.19-1.42c0-0.62-0.37-1.27-1.32-1.27C329.51,300.6,329.03,301.18,329.03,301.85z"
            />
    </g>
    <g>
        <path class="st5" d="M344.45,307.03c0.23,0.02,0.49,0,0.85-0.04c0.61-0.08,1.19-0.34,1.63-0.76c0.52-0.47,0.89-1.15,1.03-2.07
            h-0.04c-0.43,0.53-1.06,0.84-1.83,0.84c-1.4,0-2.3-1.06-2.3-2.39c0-1.48,1.07-2.77,2.66-2.77s2.58,1.3,2.58,3.29
            c0,1.72-0.58,2.91-1.34,3.66c-0.6,0.59-1.43,0.95-2.27,1.04c-0.38,0.06-0.72,0.07-0.97,0.06V307.03z M344.84,302.55
            c0,0.97,0.59,1.65,1.5,1.65c0.71,0,1.26-0.35,1.54-0.82c0.06-0.1,0.1-0.22,0.1-0.38c0-1.33-0.49-2.35-1.59-2.35
            C345.47,300.65,344.84,301.44,344.84,302.55z"/>
    </g>
    <g>
        <path class="st5" d="M359.06,300.96h-0.02l-1.36,0.73l-0.2-0.8l1.7-0.91h0.9v7.8h-1.02V300.96z"/>
        <path class="st5" d="M368.11,303.79c0,2.65-0.98,4.11-2.71,4.11c-1.52,0-2.55-1.43-2.58-4.01c0-2.61,1.13-4.05,2.71-4.05
            C367.17,299.85,368.11,301.31,368.11,303.79z M363.88,303.92c0,2.03,0.62,3.18,1.58,3.18c1.08,0,1.59-1.26,1.59-3.25
            c0-1.92-0.49-3.18-1.58-3.18C364.55,300.66,363.88,301.79,363.88,303.92z"/>
    </g>
    <g>
        <rect x="416" y="241" class="st8" width="96" height="29"/>
        <polygon class="st15" points="490,241 467,241 445,241 445,246.8 467,246.8 467,270 512,270 512,241"/>
    </g>
    <!--right MDR- -->
    <g class="pin">
        <rect x="491.25" y="249.75" class="st13" width="11.51" height="11.51"/>
        <path class="st16" d="M504.03,262.53h-14.07v-14.07h14.07V262.53z M492.52,259.98h8.95v-8.95h-8.95V259.98z"/>
        <rect :id="`${pincode}RM`" @click="onClick(`${pincode}RM`)" class="pin-cover terminal" x="491" y="249" width="15" height="15"/>
        <text transform="matrix(1 0 0 1 520 258)" class="pin-name">MINUS</text>
    </g>
    <g>
        <rect x="416" y="211" class="st8" width="96" height="29"/>
        <polygon class="st15" points="490,211 467,211 445,211 445,216.8 467,216.8 467,240 512,240 512,211"/>
    </g>
    <!--right MDR+ -->
    <g class="pin">
        <rect x="491.25" y="219.75" class="st13" width="11.51" height="11.51"/>
        <path class="st16" d="M504.03,232.53h-14.07v-14.07h14.07V232.53z M492.52,229.98h8.95v-8.95h-8.95V229.98z"/>
        <rect :id="`${pincode}RP`" @click="onClick(`${pincode}RP`)" class="pin-cover terminal" x="491" y="219" width="15" height="15"/>
        <text transform="matrix(1 0 0 1 520 228)" class="pin-name">PLUS</text>
    </g>
    <circle class="st6" cx="188.17" cy="221.83" r="15.83"/>
    <g>
        <circle class="st7" cx="188.17" cy="221.83" r="10.66"/>
        <circle class="st8" cx="188.17" cy="221.83" r="8.62"/>
    </g>
    <circle class="st6" cx="188.17" cy="257.9" r="15.83"/>
    <g>
        <circle class="st9" cx="188.17" cy="257.9" r="10.66"/>
        <circle class="st10" cx="188.17" cy="257.9" r="8.62"/>
    </g>
    <g>
        <rect x="68" y="241" transform="matrix(-1 -4.488733e-11 4.488733e-11 -1 232 511)" class="st8" width="96" height="29"/>
        <polygon class="st15" points="90,241 113,241 135,241 135,246.8 113,246.8 113,270 68,270 68,241"/>
    </g>
    <!--left MDL- -->
    <g class="pin">
        <rect x="77.25" y="249.75" class="st13" width="11.51" height="11.51"/>
        <path class="st16" d="M75.97,248.47h14.07v14.07H75.97V248.47z M87.48,251.03h-8.95v8.95h8.95V251.03z"/>
        <rect :id="`${pincode}LM`" @click="onClick(`${pincode}LM`)" class="pin-cover terminal" x="77" y="249" width="15" height="15"/>
        <text transform="matrix(1 0 0 1 0 258)" class="pin-name">MINUS</text>
    </g>
    <g>
        <rect x="68" y="211" transform="matrix(-1 -4.488733e-11 4.488733e-11 -1 232 451)" class="st8" width="96" height="29"/>
        <polygon class="st15" points="90,211 113,211 135,211 135,216.8 113,216.8 113,240 68,240 68,211"/>
    </g>
    <!--left MDL+ -->
    <g class="pin">
        <rect x="77.25" y="219.75" class="st13" width="11.51" height="11.51"/>
        <path class="st16" d="M75.97,218.47h14.07v14.07H75.97V218.47z M87.48,221.03h-8.95v8.95h8.95V221.03z"/>
        <rect :id="`${pincode}LP`" @click="onClick(`${pincode}LP`)" class="pin-cover terminal" x="77" y="219" width="15" height="15"/>
        <text transform="matrix(1 0 0 1 10 228)" class="pin-name">PLUS</text>
    </g>
    <g>
        <path class="st5" d="M367,158H215.53V95.5c0-5.52,4.48-10,10-10H357c5.52,0,10,4.48,10,10V158z"/>
        <path class="st6" d="M362.25,96c-2.62,0-4.75,2.13-4.75,4.75V136h-18.9v-35.25c0-2.62-2.13-4.75-4.75-4.75s-4.75,2.13-4.75,4.75
            V136h-18.9v-35.25c0-2.62-2.13-4.75-4.75-4.75s-4.75,2.13-4.75,4.75V136h-18.9v-35.25c0-2.62-2.13-4.75-4.75-4.75
            s-4.75,2.13-4.75,4.75V136h-18.9v-35.25c0-2.62-2.13-4.75-4.75-4.75s-4.75,2.13-4.75,4.75V136H225v-35.25
            c0-2.62-2.13-4.75-4.75-4.75s-4.75,2.13-4.75,4.75v37.5c0,0.11,0.03,0.22,0.03,0.33V176H367v-37.75V136v-35.25
            C367,98.13,364.87,96,362.25,96z"/>
        <rect x="244" y="149" class="st5" width="95" height="6"/>
    </g>
    <g>
        <circle class="st17" cx="176" cy="117.5" r="27.5"/>
        <circle class="st5" cx="176" cy="117.5" r="21.5"/>
        <polygon class="st18" points="190.14,101.24 176.35,115.03 162.21,100.88 159.38,103.71 173.53,117.85 159.74,131.64
            162.56,134.47 176.35,120.68 189.79,134.12 192.62,131.29 179.18,117.85 192.97,104.06"/>
    </g>
    <g>
        <circle class="st6" cx="152.48" cy="172.35" r="27.5"/>
        <g>
            <path class="st5" d="M152.83,156.52v2.59h2.49v0.66h-2.49v2.61h-0.7v-2.61h-2.49v-0.66h2.49v-2.59H152.83z"/>
            <path class="st5" d="M146.67,168.16h0.96v3.58h0.03c0.2-0.29,0.4-0.55,0.58-0.79l2.27-2.78h1.19l-2.68,3.15l2.89,4.27h-1.13
                l-2.44-3.64l-0.7,0.81v2.83h-0.96V168.16z"/>
            <path class="st5" d="M152.63,168.26c0.58-0.09,1.28-0.15,2.04-0.15c1.38,0,2.35,0.32,3,0.92c0.66,0.6,1.04,1.46,1.04,2.66
                c0,1.21-0.37,2.2-1.07,2.88c-0.69,0.69-1.84,1.07-3.28,1.07c-0.68,0-1.25-0.03-1.74-0.09V168.26z M153.59,174.81
                c0.24,0.04,0.59,0.06,0.97,0.06c2.05,0,3.16-1.14,3.16-3.15c0.01-1.75-0.98-2.86-3-2.86c-0.5,0-0.87,0.04-1.12,0.1V174.81z"/>
            <path class="st5" d="M139.85,188.77v-0.59l0.76-0.74c1.83-1.74,2.65-2.66,2.66-3.74c0-0.73-0.35-1.4-1.42-1.4
                c-0.65,0-1.19,0.33-1.52,0.6l-0.31-0.68c0.5-0.42,1.2-0.73,2.02-0.73c1.54,0,2.19,1.06,2.19,2.08c0,1.32-0.96,2.39-2.46,3.84
                l-0.57,0.53v0.02h3.21v0.8H139.85z"/>
            <path class="st5" d="M147.05,188.77l-1.88-7.42h1.01l0.88,3.75c0.22,0.92,0.42,1.85,0.55,2.56h0.02c0.12-0.74,0.35-1.62,0.6-2.57
                l0.99-3.74h1l0.9,3.76c0.21,0.88,0.41,1.76,0.52,2.54h0.02c0.15-0.81,0.36-1.64,0.59-2.56l0.98-3.74h0.98l-2.1,7.42h-1l-0.94-3.86
                c-0.23-0.95-0.38-1.67-0.48-2.42h-0.02c-0.13,0.74-0.3,1.46-0.57,2.42l-1.06,3.86H147.05z"/>
            <path class="st5" d="M159.56,185.12c0,2.43-0.9,3.77-2.49,3.77c-1.4,0-2.34-1.31-2.37-3.67c0-2.4,1.03-3.72,2.49-3.72
                C158.7,181.5,159.56,182.84,159.56,185.12z M155.67,185.23c0,1.86,0.57,2.92,1.45,2.92c0.99,0,1.46-1.16,1.46-2.98
                c0-1.76-0.45-2.92-1.45-2.92C156.29,182.25,155.67,183.28,155.67,185.23z"/>
            <path class="st5" d="M164.53,182.31c-0.2-0.01-0.45,0-0.73,0.04c-1.52,0.25-2.32,1.36-2.49,2.54h0.03
                c0.34-0.45,0.94-0.82,1.73-0.82c1.27,0,2.16,0.91,2.16,2.31c0,1.31-0.89,2.52-2.38,2.52c-1.53,0-2.53-1.19-2.53-3.05
                c0-1.41,0.51-2.52,1.21-3.22c0.59-0.58,1.39-0.95,2.29-1.06c0.29-0.04,0.53-0.06,0.7-0.06V182.31z M164.25,186.43
                c0-1.02-0.58-1.64-1.47-1.64c-0.58,0-1.12,0.36-1.39,0.88c-0.07,0.11-0.11,0.25-0.11,0.43c0.02,1.18,0.56,2.05,1.57,2.05
                C163.69,188.15,164.25,187.45,164.25,186.43z"/>
        </g>
    </g>
    <g>
        <circle class="st17" cx="406.48" cy="117.5" r="27.5"/>
        <circle class="st5" cx="406.48" cy="117.5" r="21.5"/>
        <polygon class="st18" points="392.33,101.24 406.12,115.03 420.26,100.88 423.09,103.71 408.95,117.85 422.74,131.64
            419.91,134.47 406.12,120.68 392.69,134.12 389.86,131.29 403.29,117.85 389.51,104.06"/>
    </g>
    <g>
        <circle class="st6" cx="430" cy="172.35" r="27.5"/>
        <g>
            <path class="st5" d="M430.35,156.52v2.59h2.49v0.66h-2.49v2.61h-0.7v-2.61h-2.49v-0.66h2.49v-2.59H430.35z"/>
            <path class="st5" d="M424.19,168.16h0.96v3.58h0.03c0.2-0.29,0.4-0.55,0.58-0.79l2.27-2.78h1.19l-2.68,3.15l2.89,4.27h-1.13
                l-2.44-3.64l-0.7,0.81v2.83h-0.96V168.16z"/>
            <path class="st5" d="M430.15,168.26c0.58-0.09,1.28-0.15,2.04-0.15c1.38,0,2.35,0.32,3,0.92c0.66,0.6,1.04,1.46,1.04,2.66
                c0,1.21-0.37,2.2-1.07,2.88c-0.69,0.69-1.84,1.07-3.28,1.07c-0.68,0-1.25-0.03-1.74-0.09V168.26z M431.11,174.81
                c0.24,0.04,0.59,0.06,0.97,0.06c2.05,0,3.16-1.14,3.16-3.15c0.01-1.75-0.98-2.86-3-2.86c-0.5,0-0.87,0.04-1.12,0.1V174.81z"/>
            <path class="st5" d="M417.38,188.77v-0.59l0.76-0.74c1.83-1.74,2.65-2.66,2.66-3.74c0-0.73-0.35-1.4-1.42-1.4
                c-0.65,0-1.19,0.33-1.52,0.6l-0.31-0.68c0.5-0.42,1.2-0.73,2.02-0.73c1.54,0,2.19,1.06,2.19,2.08c0,1.32-0.96,2.39-2.46,3.84
                l-0.57,0.53v0.02h3.21v0.8H417.38z"/>
            <path class="st5" d="M424.57,188.77l-1.88-7.42h1.01l0.88,3.75c0.22,0.92,0.42,1.85,0.55,2.56h0.02c0.12-0.74,0.35-1.62,0.6-2.57
                l0.99-3.74h1l0.9,3.76c0.21,0.88,0.41,1.76,0.52,2.54h0.02c0.15-0.81,0.36-1.64,0.59-2.56l0.98-3.74h0.98l-2.1,7.42h-1l-0.94-3.86
                c-0.23-0.95-0.38-1.67-0.48-2.42h-0.02c-0.13,0.74-0.3,1.46-0.57,2.42l-1.06,3.86H424.57z"/>
            <path class="st5" d="M437.08,185.12c0,2.43-0.9,3.77-2.49,3.77c-1.4,0-2.34-1.31-2.37-3.67c0-2.4,1.03-3.72,2.49-3.72
                C436.22,181.5,437.08,182.84,437.08,185.12z M433.2,185.23c0,1.86,0.57,2.92,1.45,2.92c0.99,0,1.46-1.16,1.46-2.98
                c0-1.76-0.45-2.92-1.45-2.92C433.81,182.25,433.2,183.28,433.2,185.23z"/>
            <path class="st5" d="M442.05,182.31c-0.2-0.01-0.45,0-0.73,0.04c-1.52,0.25-2.32,1.36-2.49,2.54h0.03
                c0.34-0.45,0.94-0.82,1.73-0.82c1.27,0,2.16,0.91,2.16,2.31c0,1.31-0.89,2.52-2.38,2.52c-1.53,0-2.53-1.19-2.53-3.05
                c0-1.41,0.51-2.52,1.21-3.22c0.59-0.58,1.39-0.95,2.29-1.06c0.29-0.04,0.53-0.06,0.7-0.06V182.31z M441.78,186.43
                c0-1.02-0.58-1.64-1.47-1.64c-0.58,0-1.12,0.36-1.39,0.88c-0.07,0.11-0.11,0.25-0.11,0.43c0.02,1.18,0.56,2.05,1.57,2.05
                C441.22,188.15,441.78,187.45,441.78,186.43z"/>
        </g>
    </g>
    <g>
        <g>
            <rect x="263" y="181" class="st19" width="55" height="55"/>
            <g>
                <rect x="321" y="184.5" class="st20" width="4" height="5"/>
                <rect x="318" y="183.5" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="195.1" class="st20" width="4" height="5"/>
                <rect x="318" y="194.1" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="205.7" class="st20" width="4" height="5"/>
                <rect x="318" y="204.7" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="216.3" class="st20" width="4" height="5"/>
                <rect x="318" y="215.3" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="226.9" class="st20" width="4" height="5"/>
                <rect x="318" y="225.9" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="184.5" class="st20" width="4" height="5"/>
                <rect x="260" y="183.5" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="195.1" class="st20" width="4" height="5"/>
                <rect x="260" y="194.1" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="205.7" class="st20" width="4" height="5"/>
                <rect x="260" y="204.7" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="216.3" class="st20" width="4" height="5"/>
                <rect x="260" y="215.3" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="226.9" class="st20" width="4" height="5"/>
                <rect x="260" y="225.9" class="st21" width="3" height="7"/>
            </g>
        </g>
        <g>
            <rect x="263" y="202" class="st19" width="55" height="55"/>
            <g>
                <rect x="321" y="205.5" class="st20" width="4" height="5"/>
                <rect x="318" y="204.5" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="216.1" class="st20" width="4" height="5"/>
                <rect x="318" y="215.1" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="226.7" class="st20" width="4" height="5"/>
                <rect x="318" y="225.7" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="237.3" class="st20" width="4" height="5"/>
                <rect x="318" y="236.3" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="321" y="247.9" class="st20" width="4" height="5"/>
                <rect x="318" y="246.9" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="205.5" class="st20" width="4" height="5"/>
                <rect x="260" y="204.5" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="216.1" class="st20" width="4" height="5"/>
                <rect x="260" y="215.1" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="226.7" class="st20" width="4" height="5"/>
                <rect x="260" y="225.7" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="237.3" class="st20" width="4" height="5"/>
                <rect x="260" y="236.3" class="st21" width="3" height="7"/>
            </g>
            <g>
                <rect x="256" y="247.9" class="st20" width="4" height="5"/>
                <rect x="260" y="246.9" class="st21" width="3" height="7"/>
            </g>
        </g>
    </g>
    <g>
        <g>
            <rect x="211.75" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M224.53,326.45h-14.07v-14.07h14.07V326.45z M213.02,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="227.86" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M240.64,326.45h-14.07v-14.07h14.07V326.45z M229.14,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="243.97" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M256.76,326.45h-14.07v-14.07h14.07V326.45z M245.25,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="260.08" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M272.87,326.45H258.8v-14.07h14.07V326.45z M261.36,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="276.19" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M288.98,326.45h-14.07v-14.07h14.07V326.45z M277.47,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="292.3" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M305.09,326.45h-14.07v-14.07h14.07V326.45z M293.58,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="308.41" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M321.2,326.45h-14.07v-14.07h14.07V326.45z M309.69,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="324.52" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M337.31,326.45h-14.07v-14.07h14.07V326.45z M325.8,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="340.63" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M353.42,326.45h-14.07v-14.07h14.07V326.45z M341.91,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <g>
            <rect x="356.75" y="313.66" width="11.51" height="11.51"/>
            <path class="st22" d="M369.53,326.45h-14.07v-14.07h14.07V326.45z M358.02,323.89h8.95v-8.95h-8.95V323.89z"/>
        </g>
        <rect x="213" y="315" class="st4" width="9" height="165"/>
        <rect x="229.05" y="315" class="st4" width="9.07" height="165"/>
        <rect x="222" y="315" class="st2" width="7.05" height="165"/>
        <rect x="238.12" y="315" class="st2" width="7.05" height="165"/>
        <rect x="245.17" y="315" class="st4" width="9.07" height="165"/>
        <rect x="261.29" y="315" class="st4" width="9.07" height="165"/>
        <rect x="254.24" y="315" class="st2" width="7.05" height="165"/>
        <rect x="270.36" y="315" class="st2" width="7.05" height="165"/>
        <rect x="277.41" y="315" class="st4" width="9.07" height="165"/>
        <rect x="293.53" y="315" class="st4" width="9.07" height="165"/>
        <rect x="286.47" y="315" class="st2" width="7.05" height="165"/>
        <rect x="302.59" y="315" class="st2" width="7.05" height="165"/>
        <rect x="309.64" y="315" class="st4" width="9.07" height="165"/>
        <rect x="325.76" y="315" class="st4" width="9.07" height="165"/>
        <rect x="318.71" y="315" class="st2" width="7.05" height="165"/>
        <rect x="334.83" y="315" class="st2" width="7.05" height="165"/>
        <rect x="341.88" y="315" class="st4" width="9.07" height="165"/>
        <rect x="358" y="315" class="st4" width="9" height="165"/>
        <rect x="350.95" y="315" class="st2" width="7.05" height="165"/>
        <!-- start pin number 1 -->
        <g class="pin">
            <rect x="211.75" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M224.53,483.45h-14.07v-14.07h14.07V483.45z M213.02,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}L1`" @click="onClick(`${pincode}L1`)" class="pin-cover terminal" x="211" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 198 510)" class="pin-name">MDL1</text>
        </g>
        <g class="pin">
            <rect x="227.86" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M240.64,483.45h-14.07v-14.07h14.07V483.45z M229.14,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}L2`" @click="onClick(`${pincode}L2`)" class="pin-cover terminal" x="227" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 213 510)" class="pin-name">MDL2</text>
        </g>
        <g class="pin">
            <rect x="243.97" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M256.76,483.45h-14.07v-14.07h14.07V483.45z M245.25,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}LW`" @click="onClick(`${pincode}LW`)" class="pin-cover terminal" x="243" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 229 510)" class="pin-name">MDLP</text>
        </g>
        <g class="pin">
            <rect x="260.08" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M272.87,483.45H258.8v-14.07h14.07V483.45z M261.36,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}LE`" @click="onClick(`${pincode}LE`)" class="pin-cover terminal" x="260" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 246 510)" class="pin-name">MDLE</text>
        </g>
        <g class="pin">
            <rect x="276.19" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M288.98,483.45h-14.07v-14.07h14.07V483.45z M277.47,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}R1`" @click="onClick(`${pincode}R1`)" class="pin-cover terminal" x="276" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 262 510)" class="pin-name">MDR1</text>
        </g>
        <g class="pin">
            <rect x="292.3" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M305.09,483.45h-14.07v-14.07h14.07V483.45z M293.58,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}R2`" @click="onClick(`${pincode}R2`)" class="pin-cover terminal" x="292" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 278 510)" class="pin-name">MDR2</text>
        </g>
        <g class="pin">
            <rect x="308.41" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M321.2,483.45h-14.07v-14.07h14.07V483.45z M309.69,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}RW`" @click="onClick(`${pincode}RW`)" class="pin-cover terminal" x="308" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 284 510)" class="pin-name">MDRP</text>
        </g>
        <g class="pin">
            <rect x="324.52" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M337.31,483.45h-14.07v-14.07h14.07V483.45z M325.8,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}RE`" @click="onClick(`${pincode}RE`)" class="pin-cover terminal" x="324" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 310 510)" class="pin-name">MDRE</text>
        </g>
        <g class="pin">
            <rect x="340.63" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M353.42,483.45h-14.07v-14.07h14.07V483.45z M341.91,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}PS`" @click="onClick(`${pincode}PS`)" class="pin-cover terminal" x="340" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 326 510)" class="pin-name">MD+</text>
        </g>
        <g class="pin">
            <rect x="356.75" y="470.66" class="st23" width="11.51" height="11.51"/>
            <path class="st23" d="M369.53,483.45h-14.07v-14.07h14.07V483.45z M358.02,480.89h8.95v-8.95h-8.95V480.89z"/>
            <rect :id="`${pincode}MS`" @click="onClick(`${pincode}MS`)" class="pin-cover terminal" x="356" y="470" width="15" height="15"/>
            <text transform="matrix(1 0 0 1 342 510)" class="pin-name">MD-</text>
        </g>
    </g>
  </g>
</g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'DCMotorDriver',
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin-name{
  display: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
 }
 .pin-name{
    display: block;
    font-size: 20px;
 }
}
.selected{
  & path.st0{
    fill: #ff6f61;
  }
}
.disable:hover{
    cursor: not-allowed;
}
.name{font-size: 24px;}
.st0{fill:none;}
.st1{fill:#F47171;}
.st2{fill:#666666;}
.st3{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
.st4{fill:#808080;}
.st5{fill:#FFFFFF;}
.st6{fill:#252324;}
.st7{fill:#576C3F;}
.st8{fill:#8DB861;}
.st9{fill:#701D1F;}
.st10{fill:#BA382F;}
.st11{fill:#CBCBC6;}
.st12{fill:#252324;stroke:#333333;stroke-width:5;stroke-miterlimit:10;}
.st13{fill:#EFEFEF;}
.st14{fill:#B47E79;}
.st15{fill:#BF4611;}
.st16{fill:#632E02;}
.st17{fill:#3572BC;}
.st18{fill:#E6E6E6;}
.st19{fill:#333333;}
.st20{fill:#E0E3DD;}
.st21{fill:#83746F;}
.st22{fill:#514E55;}
.st23{fill:#4D4D4D; stroke: #323131; stroke-width: 2px;}
</style>
